<template>
  <BaseForm
    :key="feedmillId || 'new'"
    :title="formTitle"
    :formData="feedmillData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import axios from 'axios';
import BaseForm from './BaseForm.vue';

export default {
  name: 'FeedmillForm',
  components: {
    BaseForm
  },
  props: {
    /**
     * feedmillId is null if creating a new Feedmill,
     * otherwise it is the ID of the existing feedmill to edit.
     */
    feedmillId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      feedmillData: {
        name: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        office_phone: '',
        contact_person: '',
        cell_phone: '',
        fax: '',
        email: '',
        rate: '',
        mile_rate: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'address_line1', label: 'Address Line 1', type: 'text' },
        { model: 'address_line2', label: 'Address Line 2', type: 'text' },
        { model: 'city', label: 'City', type: 'text' },
        { model: 'state', label: 'State', type: 'text' },
        { model: 'zip_code', label: 'Zip Code', type: 'text' },
        { model: 'office_phone', label: 'Office Phone', type: 'text' },
        { model: 'contact_person', label: 'Contact Person', type: 'text' },
        { model: 'cell_phone', label: 'Cell Phone', type: 'text' },
        { model: 'fax', label: 'Fax', type: 'text' },
        { model: 'email', label: 'Email', type: 'email' },
        {
          model: 'rate',
          label: 'Rate',
          type: 'number',
          step: '0.01'
        },
        {
          model: 'mile_rate',
          label: 'Mile Rate',
          type: 'number',
          step: '0.01'
        }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.feedmillId ? 'Edit Feedmill' : 'Add Feedmill';
    },
    submitUrl() {
      // Point this to your actual feedmill endpoint
      return this.feedmillId
        ? `/api/v1/feedmill/feedmills/${this.feedmillId}/`
        : '/api/v1/feedmill/feedmills/';
    },
    method() {
      return this.feedmillId ? 'put' : 'post';
    }
  },
  mounted() {
    console.log('X', this.feedmillId);
    if (this.feedmillId) {
      this.loadFeedmillData();
    }
  },
  methods: {
    loadFeedmillData() {
      axios
        .get(`/api/v1/feedmill/feedmills/${this.feedmillId}/`)
        .then(response => {
          this.feedmillData = {
            ...this.feedmillData,
            ...response.data
          };
        })
        .catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Feedmill saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the feedmill!',
        icon: 'warning',
        timeout: 3000
      });
    }
  }
};
</script>
